export default __webpack_public_path__ + "static/media/417hz-release-the-past.3820a265.jpg";